import styled from 'styled-components';

export const InputContainer = styled.div`
    position: relative;
    width: 100%;
    height: 5rem;

    + .input {
        margin-top: 3rem;
    }

    input {
        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;
        padding: 0 2.5rem;

        font-size: 1.5rem;
        font-weight: 700;

        background: transparent;
        color: #000;

        border: 1px solid #333;
        border-radius: .7rem;

        &::placeholder {
            font-weight: 500;
        }
        
        &:focus, &:valid {
            & + label {
                top: 0;
                left: 1rem;

                font-weight: 600;
                font-size: 1.4rem;
                padding: 0 .3rem;

                background: #fff;
            }
        }

        &:focus {
            border: 2px solid #000;

            & ~ .line {
                &::after {
                    transform: scaleX(1);
                }
            }
        }
    }

    label {
        position: absolute;
        top: 2.5rem;
        left: 2.5rem;
        transform: translateY(-50%);
        z-index: 5;

        font-size: 1.6rem;
        font-weight: 500;
        text-transform: capitalize;

        transition: .3s;
        pointer-events: none;
        user-select: none;
    }

    .line {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: #333;

        &::after {
            position: absolute;
            content: '';
            top: 0;
            left: 0;
            width: 100%;
            height: 2px;
            background: var(--color-primary);
            transform: scaleX(0);
            transition: .3s;
        }
    }

    @media (max-width: 540px) {
        height: 12.5vw;

        + .input {
            margin-top: 8.33333vw;
        }

        input, textarea {
            padding: 0 5.55556vw;
            font-size: 3.88889vw;

            &:focus, &:valid {
                & + label {
                    font-size: 3.33333vw;
                }
            }
        }

        label {
            top: 6.94444vw;
            left: 5.55556vw;
            font-size: 3.33333vw;
        }

        .line {
            height: 0.55556vw;

            &::after {
                height: 0.58333vw;
            }
        }
    }
`;